import { useQuery } from "@tanstack/react-query";
import { fetchOptionalDatasources } from "../services/karliApiService";
import { useAuth } from "../contexts/AuthContext";
import { OptionalDatasource } from "../types";

const FALLBACK_OPTIONS: OptionalDatasource[] = [
  { id: "fallback-1", dataSourceId: "AT", label: "Österreich", defaultActive: true },
  { id: "fallback-2", dataSourceId: "DE", label: "Deutschland", defaultActive: false },
];

export function useOptionalDatasources() {
  const { getValidAccessToken, isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: ["optionalDatasources"],
    queryFn: async () => {
      const accessToken = await getValidAccessToken();
      return fetchOptionalDatasources(accessToken);
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  });

  const options = query.data && query.data.length > 0 ? query.data : FALLBACK_OPTIONS;
  const defaultOption = options.find((o) => o.defaultActive) || options[0];

  return {
    options,
    defaultOption,
    isLoading: query.isLoading,
    isError: query.isError,
    isFallback: !query.data || query.data.length === 0,
  };
}
